import { gql } from '@apollo/client';

export const ADD_EXERCISE = gql`
    mutation addExercise($exerciseInput: ExerciseInput!){
        addExercise(exerciseInput: $exerciseInput) {
            _id
        }
    }
`;
